import { PageHeading } from '@src/components/PageHeading/PageHeading';
import { Button } from '@src/components/Button/Button';
import { ChevronLeftIcon } from '@src/components/icons/ChevronLeftIcon';
import type { ReactNode } from 'react';
import { testIdAttr } from '@src/components/testId';
import './CardDetail.css';

export interface CardDetailProps {
  children: ReactNode;
  testId?: string;
  className?: string;
}

export function CardDetail({ children, testId, className = '' }: CardDetailProps) {
  return (
    <div className={`card-detail ${className}`} {...testIdAttr(testId)}>
      {children}
    </div>
  );
}

export function CardDetailCrumbs({ children }: { children: ReactNode }) {
  return <ol className="card-detail__crumbs">{children}</ol>;
}

export function CardDetailCrumbSep() {
  return (
    <li className="card-detail__sep" aria-hidden>
      /
    </li>
  );
}

export function CardDetailLayout({ children, sideFirst = false }: { children: ReactNode; sideFirst?: boolean }) {
  return <div className={`card-detail__layout${sideFirst ? " card-detail__layout--side-first" : ""}`}>{children}</div>;
}

export function CardDetailHeader({
  title,
  backLabel,
  onBack,
  testId,
}: {
  title: string;
  backLabel: string;
  onBack: () => void;
  testId?: string;
}) {
  return (
    <header className="card-detail__header">
      <Button
        variant="ghost"
        size="small"
        icon={<ChevronLeftIcon />}
        onClick={onBack}
        testId={testId}
      >
        {backLabel}
      </Button>
      <PageHeading title={<>{title}</>} />
    </header>
  );
}
